import React, { useState } from "react";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { State } from "../../store";
import getDelphiNumber from "../../../utils/getDelphiNumber";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";

const AccountCardPanel: React.FC = () => {
  const isDesktop = useDesktopSize();
  const userData = useSelector((state: State) => state.auth.userData);
  const [openCard, setOpenCard] = useState(false);
  return (
    <div className={"panel-account-card"}>
      <h3>Twoja Karta</h3>
      {!isDesktop && (
        <button className={"secondary-button"} onClick={() => setOpenCard(!openCard)}>
          {openCard ? "Ukryj kartę" : "Pokaż kartę"}
        </button>
      )}
      <div className={isDesktop || openCard ? "qr-panel" : "qr-panel hidden-panel"}>
        <QRCode value={getDelphiNumber(userData.account)} size={100} />
      </div>
    </div>
  );
};

export default AccountCardPanel;
